import classNames from 'classnames';
import React, { FC, useState, ReactElement, useEffect } from 'react';

import { Nullable } from 'src/types/nullable.type';

interface ImageRendererProps {
  src: string;
  srcSet?: string;
  alt?: string;
  className?: any;
  errorHTML?: Nullable<ReactElement>;
  showOverlay?: boolean;
  overlayClasses?: any;
  showLoading?: boolean;
}

export const ImageRenderer: FC<ImageRendererProps> = ({
  src,
  srcSet,
  alt,
  className,
  errorHTML = null,
  showOverlay = false,
  overlayClasses,
  showLoading = false,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const onError = () => {
    setHasError(true);
  };

  useEffect(() => {
    isLoaded && !src && setIsLoaded(false);
  }, [isLoaded, src]);

  const imgClass = classNames(className, {
    'opacity-0': !isLoaded,
    'opacity-100 transition ease-in': isLoaded,
  });

  if (!hasError) {
    return (
      <>
        <img
          className={imgClass}
          src={src}
          onLoad={() => setIsLoaded(true)}
          onError={onError}
          alt={alt || 'Image'}
          {...(srcSet && { srcSet })}
        />
        {showOverlay && (
          <div
            className={classNames('absolute inset-0 bg-bedrock-black-overlay', overlayClasses, {
              'opacity-0': !isLoaded,
              'opacity-100 transition ease-in': isLoaded,
            })}
          />
        )}
        {showLoading && !isLoaded && (
          <div className={classNames('absolute inset-0 bg-bedrock-gray-medium', overlayClasses)} />
        )}
      </>
    );
  }

  return errorHTML;
};
